import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { FlexModule } from "@vp/shared/directives/flex";
import { PhoneInputComponent } from "./phone-input.component";

@NgModule({
  imports: [
    CommonModule,
    FlexModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule
  ],
  declarations: [PhoneInputComponent],
  exports: [PhoneInputComponent]
})
export class PhoneInputModule {}
